
export default {
  props: {
    propsData: {
      type: Object,
      default: () => {
        return {}
      },
    },
    siderList: {
      type: Array,
      default: () => {
        return []
      },
    },
    searchBarFixed: {
      type: Boolean,
      default: false,
    },
    offsetBottom: {
      type: Number,
      default: 0,
    },
  },
  data() {
    return {
      detailName: '',
      footerHeight: 0,
    }
  },
  computed: {
    getBottomOffset() {
      return this.offsetBottom + this.footerHeight + 'px'
    },
  },
  watch: {
    offsetBottom(val) {},
  },
  created() {
    this.setDefaultActive()
  },
  mounted() {
    this.setHeight()
    this.setFooter()

  },
  methods: {
    setDefaultActive() {
      // 选中
      const fullPath = this.$route.fullPath
      const path = fullPath.split('?')[0]
      const pathList = path.split('/')
      const detailName = pathList[pathList.length - 1]
      this.detailName = detailName
    },
    setHeight() {
      const height = document.querySelector('#header')?.offsetHeight
      this.$refs.wrapper.style.top = `${height}px`
    },
    setFooter() {
      const offseHeight = document.querySelector('.footer-wrapper')?.offsetHeight
      this.footerHeight = offseHeight
    },
  },

}
